import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'

const RenameRoomPopup: React.FC<{
  onClose: () => void
  onSave: (name: string) => void
  name: string
}> = ({
  onClose,
  onSave,
  name,
}) => {
  const [newName, setNewName] = React.useState(name)

  const ref = React.useRef<HTMLInputElement | null>(null)

  React.useEffect(() => {
    ref.current?.focus()
    ref.current?.setSelectionRange(0, newName.length)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Popup onClose={onClose}>
      <div className="title">
        Rename {name}
      </div>
      <div className="buttonStack">
        <input
          ref={ref}
          type="text"
          className="fill"
          value={newName}
          onChange={e => setNewName(e.target.value)}
        />
        <div className="buttonRow">
          <Button
            buttonStyle="green"
            onClick={() => onSave(newName)}
            disabled={newName.trim().length === 0}
          >
            Save
          </Button>
          <Button
            buttonStyle="redStroke"
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Popup>
  )
}

export default RenameRoomPopup